import React, {useState, useMemo} from 'react';
import isValidElement from './isValidElement';
import puzzles from './puzzles/batch_001';
import './App.css';

function App() {
  let savedPuzzleIndex = parseInt(localStorage.puzzleIndex);
  let progress = localStorage.progress;

  if (typeof puzzles[savedPuzzleIndex] === 'undefined') {
    savedPuzzleIndex = 0;
  }
  const [puzzleIndex, setPuzzleIndex] = useState(savedPuzzleIndex);
  const initialBoard = puzzles[puzzleIndex];
  const [initialBoardArray, setInitalBoardArray] = useState(initialBoard.split(''));
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [boardArray, setBoardArray] = useState(progress ? progress.split('') : initialBoardArray.slice());

  const invalidIndexes = useMemo(
    () => [...boardArray.keys()].filter((i) => !isValidElement(i, boardArray)),
    [boardArray],
  );
  const emptyIndexes = [...boardArray.keys()].filter((i) => boardArray[i] === '.');

  const gameFinished = invalidIndexes.length === 0 && emptyIndexes.length === 0;

  return (
    <div className="App">
      <header className="App-header">
        <h1>Sudoku Noir</h1>
        <button className="NewGame" onClick={() => {
          const newPuzzleIndex = puzzleIndex + 1;
          setPuzzleIndex(newPuzzleIndex);
          localStorage.puzzleIndex = newPuzzleIndex;
          const newPuzzle = puzzles[newPuzzleIndex].split('');
          setInitalBoardArray(newPuzzle.slice());
          setBoardArray(newPuzzle.slice());
          setSelectedIndex(null);
          localStorage.progress = puzzles[newPuzzleIndex];
        }}>New Game</button>
      </header>
      <div className="Game-Container" tabIndex="2"
        onKeyDown={event => {
          if (!['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(event.key)) {
            return;
          }

          event.preventDefault();
          event.stopPropagation();

          if (selectedIndex === null) {
            setSelectedIndex(0);
            return false;
          }

          switch (event.key) {
            case 'ArrowUp':
              if (selectedIndex > 8) {
                setSelectedIndex(selectedIndex - 9);
              }
              break;
            case 'ArrowDown':
              if (selectedIndex < 72) {
                setSelectedIndex(selectedIndex + 9);
              }
              break;
            case 'ArrowLeft':
              if (selectedIndex > 0) {
                setSelectedIndex(selectedIndex - 1);
              }
              break;
            case 'ArrowRight':
              if (selectedIndex < 80) {
                setSelectedIndex(selectedIndex + 1);
              }
              break;
            default:
              break;
          }

          return false;
        }}
        onKeyUp={(event) => {
          if (selectedIndex === null || initialBoardArray[selectedIndex] !== '.') {
            return;
          }
          if (['1','2','3','4','5','6','7','8','9'].includes(event.key)) {
            boardArray[selectedIndex] = event.key;
            setBoardArray(boardArray.slice());
          }
          if (event.key === 'Delete' || event.key === "Backspace") {
            boardArray[selectedIndex] = '.';
            setBoardArray(boardArray.slice());
          }
          localStorage.progress = boardArray.join('');
        }}>
        {gameFinished ? (<div className="Game-Finished"><h1 align="center">Well Done!</h1></div>) : null}
        <div className="Board">
          {boardArray.map((element, index) =>
            <div
              key={index}
              className={
                'Board-Element' + // base class
                (initialBoardArray[index] !== '.' ? ' disabled' : '') + // disable initial values
                (selectedIndex === index ? ' selected' : '') + // highlight user selected cell
                (element !== '.' ? ' color' + element : '')  + // add color to each number
                ((selectedIndex !== null && selectedIndex !== index && boardArray[selectedIndex] !== '.' && element === boardArray[selectedIndex]) ? ' highlight' : '') + // highlight same numbers
                (invalidIndexes.includes(index) ? ' error' : '')  // mark invalid elements
              }
              onClick={() => {
                if (selectedIndex !== index) {
                  setSelectedIndex(index);
                } else {
                  setSelectedIndex(null);
                }
              }}>
              {(element !== '.' ? element : '')/* + '_' + index*/}
            </div>
          )}
        </div>
        <div className="Actions">
          {['1','2','3','4','5','6','7','8','9'].map((e, i) => (
            <button key={i} onClick={() => {
              if (selectedIndex === null || initialBoardArray[selectedIndex] !== '.') {
                return;
              }

              boardArray[selectedIndex] = e;
              setBoardArray(boardArray.slice());

              localStorage.progress = boardArray.join('');
            }}>{e}</button>
          ))}
          <button onClick={() => {
            if (selectedIndex === null || initialBoardArray[selectedIndex] !== '.') {
              return;
            }

            boardArray[selectedIndex] = '.';
            setBoardArray(boardArray.slice());

            localStorage.progress = boardArray.join('');
          }}><i className="material-icons">delete</i></button>
        </div>
      </div>
      <div className="About">
        <h2>About</h2>
        <p>Sudoku is a number-placement logic puzzle.</p>
        <p>The goal is to fill the 9×9 board with numbers from 1 through 9, so that each column, each row, and each of the nine 3×3 subgrids that compose the grid contain all of the digits. The puzzle provided is a partially completed grid, has a single solution.</p>
        <p>
        Puzzles generated by QQwing 1.3.4
        </p>
        <h2>Contact</h2>
        <p>
        Send feedback and questions via email: sudokunoirapp [ at ] gmail [ dot ] com.
        </p>
        <h2>Controls</h2>
        <p>Sudoku can be played using the keyboard, the mouse, or any combination of the two. Use the mouse or the arrow keys to select a cell. Once a cell is selected, a number can be added by keyboard or mouse using the buttons provided.</p>
      </div>
      <footer>
        <p>
          Copyright © 2020 - <a href="https://www.sebastianrus.com/">www.sebastianrus.com</a> - All rights reserved.
        </p>
      </footer>
    </div>
  );
}

export default App;
